module.exports = __webpack_public_path__ + "img/yydelay.d85cc25.png";